const clearNewAlerts = (rawData) => {
  const updatedAlertsList = rawData.map((alert) => {
    if (alert.isNew) {
      return { ...alert, isNew: false };
    }
    return alert;
  });

  return updatedAlertsList;
};

const parseProduct = (rawData) => {
  const product = rawData.products[0] || {};
  return product;
};

const assembly = {
  clearNewAlerts,
  parseProduct,
};

export default assembly;
